import { ActionWithPayload } from 'app/helpers';
import { TrackingPage } from './tracking-page.model';
import { TrackingPageModel } from 'app/core';
import { Action } from '@ngrx/store';

export enum TrackingPageActionTypes {
  BOOTSTRAP = '[Tracking Page] Bootstrap',
  BOOTSTRAP_SUCCESS = '[Tracking Page] Bootstrap Success',
  FETCH_TRACKING_PAGE_BY_SUBDOMAIN = '[Tracking Page] Fetch Tracking Page By Subdomain',
  SET_TRACKING_PAGE = '[Tracking Page] Set Tracking Page',
  FIND_TRACKING_PAGE_NUMBER = '[Tracking Page] Find Tracking Page Number',
  NO_TRACKING_NUMBER_FOUND = '[Tracking Page] No Tracking Number Found',
  BACK_TO_SEARCH = '[Tracking Page] Back To Search',
  SET_DEFAULT_TRACKING_PAGE = '[Tracking Page] Set Default Tracking Page'
}

export interface BootstrapPayload {
  hash: string;
  locale: string;
  redirectOnError?: boolean;
  domain?: string;
}

export class BootstrapTrackingPage
  implements ActionWithPayload<BootstrapPayload> {
  public readonly type = TrackingPageActionTypes.BOOTSTRAP;
  constructor(public payload: BootstrapPayload) {}
}

export interface BootstrapTrackingPageSuccessPayload {
  sidebarItems: {
    items: any[];
    totalItems: number;
  };
  mainItems: {
    items: any;
    totalItems: number;
  };
  trackingPage: TrackingPage;
  hash?: any;
}
export class BootstrapTrackingPageSuccess
  implements ActionWithPayload<BootstrapTrackingPageSuccessPayload> {
  public readonly type = TrackingPageActionTypes.BOOTSTRAP_SUCCESS;
  constructor(public payload: BootstrapTrackingPageSuccessPayload) {}
}

export class FetchTrackingPageBySubdomain
  implements
    ActionWithPayload<{
      subdomain: string;
      locale: string;
      redirectOnError?: boolean;
    }> {
  public readonly type =
    TrackingPageActionTypes.FETCH_TRACKING_PAGE_BY_SUBDOMAIN;
  constructor(
    public payload: {
      subdomain: string;
      locale: string;
      redirectOnError?: boolean;
    }
  ) {}
}

export class SetTrackingPage implements ActionWithPayload<TrackingPageModel> {
  public readonly type = TrackingPageActionTypes.SET_TRACKING_PAGE;
  constructor(public payload: TrackingPageModel) {}
}

export interface FindTrackingPageNumberPayload {
  locale: string;
  subdomain: string;
  searchText: string;
}

export class FindTrackingPageNumber
  implements ActionWithPayload<FindTrackingPageNumberPayload> {
  public readonly type = TrackingPageActionTypes.FIND_TRACKING_PAGE_NUMBER;
  constructor(public payload: FindTrackingPageNumberPayload) {}
}

export class NoTrackingNumberFound
  implements ActionWithPayload<string | boolean> {
  public readonly type = TrackingPageActionTypes.NO_TRACKING_NUMBER_FOUND;
  constructor(public payload: string | boolean = true) {}
}

export class BackToSearch implements Action {
  public readonly type = TrackingPageActionTypes.BACK_TO_SEARCH;
}

export class SetDefaultTrackingPage implements Action {
  public readonly type = TrackingPageActionTypes.SET_DEFAULT_TRACKING_PAGE;
}

export type TrackingPageActions =
  | BootstrapTrackingPage
  | BootstrapTrackingPageSuccess
  | FetchTrackingPageBySubdomain
  | SetTrackingPage
  | FindTrackingPageNumber
  | NoTrackingNumberFound
  | BackToSearch
  | SetDefaultTrackingPage;
